import React, { useEffect } from 'react'
import { formatDateTime, getDateTime } from '../utils/Helper'

function QuantityHistory(props:any) {


  return (
    <>
     <div className="modal fade com-modal short-modal view-history-modal show" id="viewQuantityHistory" aria-labelledby="viewQuantityHistoryLabel" aria-hidden="false" style={{ display: 'block' }} >
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="viewQuantityHistoryLabel">View History</h5>
                            <button type="button" onClick={()=>props?.setHistoryShow(false)} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <div className="modal-body pb-0 px-0">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>S. No</th>
                                            <th className="text-start">Old Quantity</th>
                                            <th className="text-start">New Quantity</th>
                                            <th className="text-start">Date</th>
                                            <th className="text-start">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props?.data?.map((res:any ,i:any)=>(
                                            <tr key={i}>
                                            <td className="text-center">{i+1}</td>
                                            <td>{res?.pre_quantity}</td>
                                            <td>{res?.new_quantity}</td>
                                            <td>{formatDateTime(res?.created_at).formattedDate}</td>
                                            <td className={res?.status == "1" ? "approved-text" : res?.status == "0" ? "yellow-text" : "red-text"}>{res?.status == "1" ? "Approved" : res?.status == "0" ? "Pending" :"Rejected"}</td>
                                        </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </>
  )
}

export default QuantityHistory